import { NoOp } from '../types/types';

const noOp: NoOp = () => null;
export default noOp;
